import ajax from "./ajax";

export function applyJobApplication(data) {
  return ajax(`/JobApplications`, { method: "POST", data });
}

export function getJobApplications(params = '') {
  return ajax(`/JobApplications?sort=-id${params}`);
}
// Add this to your API service file

export function getEmployerJobApplications(employerId, jobId = "") {
  // This builds the exact URL: /JobApplications?sort=-id&employer_id=58&job_id=...
  const jobParam = jobId ? `&job_id=${jobId}` : "";
  return ajax(`/JobApplications?sort=-id&employer_id=${employerId}${jobParam}`);
}

export function getSingleJobApplication(id) {
  return ajax(`/jobapplications/${id}`);
}

export function updateApplicationStatus({ id, status, rejectionReason }) {
  console.log("🚀 API CALL STATUS:", {
    url: `/JobApplications/change-status?id=${id}`,
    body: {
      status,
      rejectionReason,
    },
  });

  return ajax(`/JobApplications/change-status?id=${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      status,
      rejectionReason,
    },
  });
}
